/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BeginChatRequest,
  BeginChatResponse,
  GetLastChatInfoResponse,
  GetPromptLibraryResponse,
  GetThreadMessagesResponse,
  GetThreadSuggestedPromptsRequest,
  GetThreadSuggestedPromptsResponse,
  ListSuggestedPromptsResponse,
  ListThreadsResponse,
  PinThreadRequest,
  RenameThreadRequest,
  SendGeneralSupportRequest,
  SendMessageRequest,
  SendMessageResponse,
  SendPromptResponse,
  SendSupportRequest,
  SendSupportRequestResponse,
} from '../models/index';
import {
    BeginChatRequestFromJSON,
    BeginChatRequestToJSON,
    BeginChatResponseFromJSON,
    BeginChatResponseToJSON,
    GetLastChatInfoResponseFromJSON,
    GetLastChatInfoResponseToJSON,
    GetPromptLibraryResponseFromJSON,
    GetPromptLibraryResponseToJSON,
    GetThreadMessagesResponseFromJSON,
    GetThreadMessagesResponseToJSON,
    GetThreadSuggestedPromptsRequestFromJSON,
    GetThreadSuggestedPromptsRequestToJSON,
    GetThreadSuggestedPromptsResponseFromJSON,
    GetThreadSuggestedPromptsResponseToJSON,
    ListSuggestedPromptsResponseFromJSON,
    ListSuggestedPromptsResponseToJSON,
    ListThreadsResponseFromJSON,
    ListThreadsResponseToJSON,
    PinThreadRequestFromJSON,
    PinThreadRequestToJSON,
    RenameThreadRequestFromJSON,
    RenameThreadRequestToJSON,
    SendGeneralSupportRequestFromJSON,
    SendGeneralSupportRequestToJSON,
    SendMessageRequestFromJSON,
    SendMessageRequestToJSON,
    SendMessageResponseFromJSON,
    SendMessageResponseToJSON,
    SendPromptResponseFromJSON,
    SendPromptResponseToJSON,
    SendSupportRequestFromJSON,
    SendSupportRequestToJSON,
    SendSupportRequestResponseFromJSON,
    SendSupportRequestResponseToJSON,
} from '../models/index';

export interface ChatControllerBeginNewChatAndRenameWithAIRequest {
    beginChatRequest: BeginChatRequest;
}

export interface ChatControllerDeleteRunRequest {
    thread: string;
}

export interface ChatControllerDeleteThreadRequest {
    thread: string;
}

export interface ChatControllerGenerateThreadSuggestedPromptsRequest {
    thread: string;
    getThreadSuggestedPromptsRequest: GetThreadSuggestedPromptsRequest;
}

export interface ChatControllerGetThreadMessagesRequest {
    thread: string;
    page?: number;
    pageSize?: number;
}

export interface ChatControllerPinThreadRequest {
    thread: string;
    pinThreadRequest: PinThreadRequest;
}

export interface ChatControllerRenameThreadRequest {
    thread: string;
    renameThreadRequest: RenameThreadRequest;
}

export interface ChatControllerSendGeneralSupportRequestRequest {
    sendGeneralSupportRequest: SendGeneralSupportRequest;
}

export interface ChatControllerSendMessageAndGetStreamRequest {
    thread: string;
    promptRefId: string;
}

export interface ChatControllerSendPromptRequest {
    thread: string;
    sendMessageRequest: SendMessageRequest;
}

export interface ChatControllerSendPromptAndGetResponseRequest {
    thread: string;
    sendMessageRequest: SendMessageRequest;
}

export interface ChatControllerSendThreadSupportRequestRequest {
    thread: string;
    sendSupportRequest: SendSupportRequest;
}

/**
 * ChatApi - interface
 * 
 * @export
 * @interface ChatApiInterface
 */
export interface ChatApiInterface {
    /**
     * 
     * @summary Create a new thread and rename it based on the first message using general AI.
     * @param {BeginChatRequest} beginChatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerBeginNewChatAndRenameWithAIRaw(requestParameters: ChatControllerBeginNewChatAndRenameWithAIRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BeginChatResponse>>;

    /**
     * Create a new thread and rename it based on the first message using general AI.
     */
    chatControllerBeginNewChatAndRenameWithAI(requestParameters: ChatControllerBeginNewChatAndRenameWithAIRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BeginChatResponse>;

    /**
     * 
     * @summary Delete a run from a thread.
     * @param {string} thread 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerDeleteRunRaw(requestParameters: ChatControllerDeleteRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a run from a thread.
     */
    chatControllerDeleteRun(requestParameters: ChatControllerDeleteRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete a thread.
     * @param {string} thread 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerDeleteThreadRaw(requestParameters: ChatControllerDeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a thread.
     */
    chatControllerDeleteThread(requestParameters: ChatControllerDeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Generate an array of prompt suggestions based on the thread context.
     * @param {string} thread 
     * @param {GetThreadSuggestedPromptsRequest} getThreadSuggestedPromptsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerGenerateThreadSuggestedPromptsRaw(requestParameters: ChatControllerGenerateThreadSuggestedPromptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThreadSuggestedPromptsResponse>>;

    /**
     * Generate an array of prompt suggestions based on the thread context.
     */
    chatControllerGenerateThreadSuggestedPrompts(requestParameters: ChatControllerGenerateThreadSuggestedPromptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThreadSuggestedPromptsResponse>;

    /**
     * 
     * @summary Retrieve the last chat info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerGetLastChatInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastChatInfoResponse>>;

    /**
     * Retrieve the last chat info.
     */
    chatControllerGetLastChatInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastChatInfoResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerGetMinimalChatUIRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    chatControllerGetMinimalChatUI(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Retrieve the full prompt library.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerGetPromptLibraryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromptLibraryResponse>>;

    /**
     * Retrieve the full prompt library.
     */
    chatControllerGetPromptLibrary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromptLibraryResponse>;

    /**
     * 
     * @summary Retrieve the messages from a thread. Use to \"resync\".
     * @param {string} thread 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerGetThreadMessagesRaw(requestParameters: ChatControllerGetThreadMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThreadMessagesResponse>>;

    /**
     * Retrieve the messages from a thread. Use to \"resync\".
     */
    chatControllerGetThreadMessages(requestParameters: ChatControllerGetThreadMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThreadMessagesResponse>;

    /**
     * 
     * @summary Retrieve the list of suggested prompts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerListSuggestedPromptsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSuggestedPromptsResponse>>;

    /**
     * Retrieve the list of suggested prompts.
     */
    chatControllerListSuggestedPrompts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSuggestedPromptsResponse>;

    /**
     * 
     * @summary Retrieve the list of threads.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerListThreadsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListThreadsResponse>>;

    /**
     * Retrieve the list of threads.
     */
    chatControllerListThreads(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListThreadsResponse>;

    /**
     * 
     * @summary Pin or Unpin a thread.
     * @param {string} thread 
     * @param {PinThreadRequest} pinThreadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerPinThreadRaw(requestParameters: ChatControllerPinThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Pin or Unpin a thread.
     */
    chatControllerPinThread(requestParameters: ChatControllerPinThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Set the title of a thread.
     * @param {string} thread 
     * @param {RenameThreadRequest} renameThreadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerRenameThreadRaw(requestParameters: ChatControllerRenameThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Set the title of a thread.
     */
    chatControllerRenameThread(requestParameters: ChatControllerRenameThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Send a general support request.
     * @param {SendGeneralSupportRequest} sendGeneralSupportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerSendGeneralSupportRequestRaw(requestParameters: ChatControllerSendGeneralSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSupportRequestResponse>>;

    /**
     * Send a general support request.
     */
    chatControllerSendGeneralSupportRequest(requestParameters: ChatControllerSendGeneralSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSupportRequestResponse>;

    /**
     * 
     * @summary Listen stream of messages.
     * @param {string} thread 
     * @param {string} promptRefId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerSendMessageAndGetStreamRaw(requestParameters: ChatControllerSendMessageAndGetStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Listen stream of messages.
     */
    chatControllerSendMessageAndGetStream(requestParameters: ChatControllerSendMessageAndGetStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Send a message to a thread and get a reference to use in the GET counterpart
     * @param {string} thread 
     * @param {SendMessageRequest} sendMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerSendPromptRaw(requestParameters: ChatControllerSendPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendPromptResponse>>;

    /**
     * Send a message to a thread and get a reference to use in the GET counterpart
     */
    chatControllerSendPrompt(requestParameters: ChatControllerSendPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendPromptResponse>;

    /**
     * 
     * @summary Send a message to a thread and get the response.
     * @param {string} thread 
     * @param {SendMessageRequest} sendMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerSendPromptAndGetResponseRaw(requestParameters: ChatControllerSendPromptAndGetResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendMessageResponse>>;

    /**
     * Send a message to a thread and get the response.
     */
    chatControllerSendPromptAndGetResponse(requestParameters: ChatControllerSendPromptAndGetResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendMessageResponse>;

    /**
     * 
     * @summary Generate an report that show inner workings of the AI.
     * @param {string} thread 
     * @param {SendSupportRequest} sendSupportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatControllerSendThreadSupportRequestRaw(requestParameters: ChatControllerSendThreadSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSupportRequestResponse>>;

    /**
     * Generate an report that show inner workings of the AI.
     */
    chatControllerSendThreadSupportRequest(requestParameters: ChatControllerSendThreadSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSupportRequestResponse>;

    /**
     * 
     * @summary Get the list of available chat providers and manage the active chat provider override.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    chatProviderControllerGetProvidersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get the list of available chat providers and manage the active chat provider override.
     */
    chatProviderControllerGetProviders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI implements ChatApiInterface {

    /**
     * Create a new thread and rename it based on the first message using general AI.
     */
    async chatControllerBeginNewChatAndRenameWithAIRaw(requestParameters: ChatControllerBeginNewChatAndRenameWithAIRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BeginChatResponse>> {
        if (requestParameters['beginChatRequest'] == null) {
            throw new runtime.RequiredError(
                'beginChatRequest',
                'Required parameter "beginChatRequest" was null or undefined when calling chatControllerBeginNewChatAndRenameWithAI().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BeginChatRequestToJSON(requestParameters['beginChatRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BeginChatResponseFromJSON(jsonValue));
    }

    /**
     * Create a new thread and rename it based on the first message using general AI.
     */
    async chatControllerBeginNewChatAndRenameWithAI(requestParameters: ChatControllerBeginNewChatAndRenameWithAIRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BeginChatResponse> {
        const response = await this.chatControllerBeginNewChatAndRenameWithAIRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a run from a thread.
     */
    async chatControllerDeleteRunRaw(requestParameters: ChatControllerDeleteRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerDeleteRun().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/thread/{thread}/run`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a run from a thread.
     */
    async chatControllerDeleteRun(requestParameters: ChatControllerDeleteRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerDeleteRunRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a thread.
     */
    async chatControllerDeleteThreadRaw(requestParameters: ChatControllerDeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerDeleteThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a thread.
     */
    async chatControllerDeleteThread(requestParameters: ChatControllerDeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerDeleteThreadRaw(requestParameters, initOverrides);
    }

    /**
     * Generate an array of prompt suggestions based on the thread context.
     */
    async chatControllerGenerateThreadSuggestedPromptsRaw(requestParameters: ChatControllerGenerateThreadSuggestedPromptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThreadSuggestedPromptsResponse>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerGenerateThreadSuggestedPrompts().'
            );
        }

        if (requestParameters['getThreadSuggestedPromptsRequest'] == null) {
            throw new runtime.RequiredError(
                'getThreadSuggestedPromptsRequest',
                'Required parameter "getThreadSuggestedPromptsRequest" was null or undefined when calling chatControllerGenerateThreadSuggestedPrompts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/message-suggestions`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetThreadSuggestedPromptsRequestToJSON(requestParameters['getThreadSuggestedPromptsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetThreadSuggestedPromptsResponseFromJSON(jsonValue));
    }

    /**
     * Generate an array of prompt suggestions based on the thread context.
     */
    async chatControllerGenerateThreadSuggestedPrompts(requestParameters: ChatControllerGenerateThreadSuggestedPromptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThreadSuggestedPromptsResponse> {
        const response = await this.chatControllerGenerateThreadSuggestedPromptsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the last chat info.
     */
    async chatControllerGetLastChatInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastChatInfoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/last`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastChatInfoResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the last chat info.
     */
    async chatControllerGetLastChatInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastChatInfoResponse> {
        const response = await this.chatControllerGetLastChatInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async chatControllerGetMinimalChatUIRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/ui`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async chatControllerGetMinimalChatUI(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerGetMinimalChatUIRaw(initOverrides);
    }

    /**
     * Retrieve the full prompt library.
     */
    async chatControllerGetPromptLibraryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPromptLibraryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/prompt-library`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromptLibraryResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the full prompt library.
     */
    async chatControllerGetPromptLibrary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPromptLibraryResponse> {
        const response = await this.chatControllerGetPromptLibraryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the messages from a thread. Use to \"resync\".
     */
    async chatControllerGetThreadMessagesRaw(requestParameters: ChatControllerGetThreadMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThreadMessagesResponse>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerGetThreadMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/messages`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetThreadMessagesResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the messages from a thread. Use to \"resync\".
     */
    async chatControllerGetThreadMessages(requestParameters: ChatControllerGetThreadMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThreadMessagesResponse> {
        const response = await this.chatControllerGetThreadMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the list of suggested prompts.
     */
    async chatControllerListSuggestedPromptsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSuggestedPromptsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/suggested-prompts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSuggestedPromptsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the list of suggested prompts.
     */
    async chatControllerListSuggestedPrompts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSuggestedPromptsResponse> {
        const response = await this.chatControllerListSuggestedPromptsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the list of threads.
     */
    async chatControllerListThreadsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListThreadsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListThreadsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the list of threads.
     */
    async chatControllerListThreads(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListThreadsResponse> {
        const response = await this.chatControllerListThreadsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Pin or Unpin a thread.
     */
    async chatControllerPinThreadRaw(requestParameters: ChatControllerPinThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerPinThread().'
            );
        }

        if (requestParameters['pinThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'pinThreadRequest',
                'Required parameter "pinThreadRequest" was null or undefined when calling chatControllerPinThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/pin`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PinThreadRequestToJSON(requestParameters['pinThreadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Pin or Unpin a thread.
     */
    async chatControllerPinThread(requestParameters: ChatControllerPinThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerPinThreadRaw(requestParameters, initOverrides);
    }

    /**
     * Set the title of a thread.
     */
    async chatControllerRenameThreadRaw(requestParameters: ChatControllerRenameThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerRenameThread().'
            );
        }

        if (requestParameters['renameThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'renameThreadRequest',
                'Required parameter "renameThreadRequest" was null or undefined when calling chatControllerRenameThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/title`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RenameThreadRequestToJSON(requestParameters['renameThreadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set the title of a thread.
     */
    async chatControllerRenameThread(requestParameters: ChatControllerRenameThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerRenameThreadRaw(requestParameters, initOverrides);
    }

    /**
     * Send a general support request.
     */
    async chatControllerSendGeneralSupportRequestRaw(requestParameters: ChatControllerSendGeneralSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSupportRequestResponse>> {
        if (requestParameters['sendGeneralSupportRequest'] == null) {
            throw new runtime.RequiredError(
                'sendGeneralSupportRequest',
                'Required parameter "sendGeneralSupportRequest" was null or undefined when calling chatControllerSendGeneralSupportRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/support-request`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendGeneralSupportRequestToJSON(requestParameters['sendGeneralSupportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendSupportRequestResponseFromJSON(jsonValue));
    }

    /**
     * Send a general support request.
     */
    async chatControllerSendGeneralSupportRequest(requestParameters: ChatControllerSendGeneralSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSupportRequestResponse> {
        const response = await this.chatControllerSendGeneralSupportRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Listen stream of messages.
     */
    async chatControllerSendMessageAndGetStreamRaw(requestParameters: ChatControllerSendMessageAndGetStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerSendMessageAndGetStream().'
            );
        }

        if (requestParameters['promptRefId'] == null) {
            throw new runtime.RequiredError(
                'promptRefId',
                'Required parameter "promptRefId" was null or undefined when calling chatControllerSendMessageAndGetStream().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/stream/{promptRefId}`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));
        urlPath = urlPath.replace(`{${"promptRefId"}}`, encodeURIComponent(String(requestParameters['promptRefId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Listen stream of messages.
     */
    async chatControllerSendMessageAndGetStream(requestParameters: ChatControllerSendMessageAndGetStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerSendMessageAndGetStreamRaw(requestParameters, initOverrides);
    }

    /**
     * Send a message to a thread and get a reference to use in the GET counterpart
     */
    async chatControllerSendPromptRaw(requestParameters: ChatControllerSendPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendPromptResponse>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerSendPrompt().'
            );
        }

        if (requestParameters['sendMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'sendMessageRequest',
                'Required parameter "sendMessageRequest" was null or undefined when calling chatControllerSendPrompt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/stream`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageRequestToJSON(requestParameters['sendMessageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendPromptResponseFromJSON(jsonValue));
    }

    /**
     * Send a message to a thread and get a reference to use in the GET counterpart
     */
    async chatControllerSendPrompt(requestParameters: ChatControllerSendPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendPromptResponse> {
        const response = await this.chatControllerSendPromptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a message to a thread and get the response.
     */
    async chatControllerSendPromptAndGetResponseRaw(requestParameters: ChatControllerSendPromptAndGetResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendMessageResponse>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerSendPromptAndGetResponse().'
            );
        }

        if (requestParameters['sendMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'sendMessageRequest',
                'Required parameter "sendMessageRequest" was null or undefined when calling chatControllerSendPromptAndGetResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/messages`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageRequestToJSON(requestParameters['sendMessageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendMessageResponseFromJSON(jsonValue));
    }

    /**
     * Send a message to a thread and get the response.
     */
    async chatControllerSendPromptAndGetResponse(requestParameters: ChatControllerSendPromptAndGetResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendMessageResponse> {
        const response = await this.chatControllerSendPromptAndGetResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate an report that show inner workings of the AI.
     */
    async chatControllerSendThreadSupportRequestRaw(requestParameters: ChatControllerSendThreadSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSupportRequestResponse>> {
        if (requestParameters['thread'] == null) {
            throw new runtime.RequiredError(
                'thread',
                'Required parameter "thread" was null or undefined when calling chatControllerSendThreadSupportRequest().'
            );
        }

        if (requestParameters['sendSupportRequest'] == null) {
            throw new runtime.RequiredError(
                'sendSupportRequest',
                'Required parameter "sendSupportRequest" was null or undefined when calling chatControllerSendThreadSupportRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/threads/{thread}/support-request`;
        urlPath = urlPath.replace(`{${"thread"}}`, encodeURIComponent(String(requestParameters['thread'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendSupportRequestToJSON(requestParameters['sendSupportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendSupportRequestResponseFromJSON(jsonValue));
    }

    /**
     * Generate an report that show inner workings of the AI.
     */
    async chatControllerSendThreadSupportRequest(requestParameters: ChatControllerSendThreadSupportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSupportRequestResponse> {
        const response = await this.chatControllerSendThreadSupportRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the list of available chat providers and manage the active chat provider override.
     */
    async chatProviderControllerGetProvidersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/providers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get the list of available chat providers and manage the active chat provider override.
     */
    async chatProviderControllerGetProviders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatProviderControllerGetProvidersRaw(initOverrides);
    }

}
